import ScatterSwap from 'scatter-swap'

export function reverseHashInt(val) {
  return parseInt(new ScatterSwap(val).reverseHash(), 10)
}

export function hash(val) {
  return new ScatterSwap(val).hash()
}

export function convertScatterIdToRaw(id) {
  if (id === 'new') return id
  return reverseHashInt(id)
}
